import { authorizedFetch, ErrorResponse } from './api-client';
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// Dental Specialties
export interface DentalSpecialty {
  id: string;
  name: string;
  status: number;
}

export async function fetchDentalSpecialties(): Promise<DentalSpecialty[]> {
  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/dental-specialties/`);

  if (!response.ok) {
    throw new Error('Erro ao buscar especialidades');
  }

  const data = await response.json();
  return data.items ?? data;
}
export async function fetchSpecialtiesByClinic(clinicId: string): Promise<DentalSpecialty[]> {
  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/clinics/${clinicId}/dental-specialties`);

  if (!response.ok) {
    throw new Error('Erro ao buscar especialidades da clínica');
  }

  return response.json();
}